import React, { useRef } from 'react';
import type { ReactElement, ReactNode } from 'react';

import { getBackgroundColor } from '@coachhubio/nova-colors';
import { Divider } from '@coachhubio/nova-divider';
import { Column } from '@coachhubio/nova-flex';
import { padding } from '@coachhubio/nova-spaces';
import { CoachingLicensesProvider } from 'context/CoachingLicensesRef';
import styled from 'styled-components';

import { DashboardTitle } from '../../components/DashboardTitle';
import { Filters } from '../../components/Filters';

type Props = {
  children: ReactNode;
};

export const NoColorWrapper = styled(Column)`
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  min-height: 100vh;
  width: 100%;
  ${getBackgroundColor('neutral')}
  ${padding('xl')}
`;

const ImpactPlusDashboardLayout = function ({ children }: Props): ReactElement {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <CoachingLicensesProvider>
      <NoColorWrapper ref={ref}>
        <DashboardTitle />
        <Filters />
        <Divider marginY="m" marginX="none" />
        {children}
      </NoColorWrapper>
    </CoachingLicensesProvider>
  );
};

export default ImpactPlusDashboardLayout;
